import React, { useState } from "react";
import { useRecommendationStore } from "../../stores/recommendationStore";
import { AddModal } from "components";
import { cashIcon, debitIcon } from "assets";
import { ROZETKA_WAREHOUSE_ID } from "../../utils/warehouses";

const INITIAL_FORM_STATE = {
  article: "",
  price: "",
  price11: "",
  price05: "",
  priceType: "debit", // 'debit' або 'cash'
};

// Компонент для додавання нової рекомендації
const RecommendationForm = () => {
  // Отримуємо дані та дії зі стору рекомендацій
  const upsertRecommendation = useRecommendationStore(
    (state) => state.upsertRecommendation,
  );
  const warehouse_id = useRecommendationStore((state) => state.filters.warehouse_id);
  const isRozetka = warehouse_id === ROZETKA_WAREHOUSE_ID;

  // Локальні стан
  const [isOpen, setIsOpen] = useState(false);
  const [formState, setFormState] = useState(INITIAL_FORM_STATE);

  // Універсальний обробник для полів вводу
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  // Функція для перемикання типу ціни
  const togglePriceType = () => {
    setFormState((prev) => ({
      ...prev,
      priceType: prev.priceType === "cash" ? "debit" : "cash",
    }));
  };

  const handleClose = () => {
    setFormState(INITIAL_FORM_STATE);
    setIsOpen(false);
  };

  // Функція обробки відправлення форми
  const handleSubmit = (e) => {
    e.preventDefault();
    const { article, price, price11, price05, priceType } = formState;

    // Створюємо префікс для полів в залежності від типу ціни
    const pricePrefix = priceType === "cash" ? "" : "_cashless";
    const dataToSend = {
      [`new_price${pricePrefix}`]: price !== "" ? parseFloat(price) : null,
      // Для Rozetka зберігаємо лише фінальну ціну
      ...(!isRozetka && {
        [`price_11${pricePrefix}`]: price11 !== "" ? parseFloat(price11) : null,
        [`price_05${pricePrefix}`]: price05 !== "" ? parseFloat(price05) : null,
      }),
    };

    // Викликаємо дію зі стору, передаючи поточний warehouse_id
    upsertRecommendation(warehouse_id, article, dataToSend);
    handleClose();
  };

  return (
    <>
      <button
        className="toggle-form-button focus-button"
        onClick={() => setIsOpen(true)}
      >
        Додати рекомендовану ціну
      </button>

      <AddModal isOpen={isOpen} onClose={handleClose} title="Додати рекомендовану ціну">
        <form onSubmit={handleSubmit}>
          <div className="add-modal-body">
            <div className="form-group">
              <label>Артикул *</label>
              <input
                name="article"
                type="text"
                placeholder="Введіть артикул"
                value={formState.article}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Тип ціни</label>
              <button
                type="button"
                className="btn-cancel"
                style={{
                  width: "fit-content",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
                onClick={togglePriceType}
              >
                <img
                  src={formState.priceType === "cash" ? cashIcon : debitIcon}
                  alt="Тип"
                  width="20"
                />
                {formState.priceType === "cash" ? "Готівка" : "Безготівка"}
              </button>
            </div>

            <div className="form-group">
              <label>{isRozetka ? "Ціна Rozetka (з комісією) *" : "РРЦ (Ціна) *"}</label>
              <input
                name="price"
                type="number"
                placeholder="Введіть ціну"
                value={formState.price}
                onChange={handleChange}
                required
              />
            </div>

            {!isRozetka && (
              <>
                <div className="form-group">
                  <label>Ціна 11</label>
                  <input
                    name="price11"
                    type="number"
                    placeholder="Необов'язково"
                    value={formState.price11}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Ціна 05</label>
                  <input
                    name="price05"
                    type="number"
                    placeholder="Необов'язково"
                    value={formState.price05}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
          </div>

          <div className="add-modal-footer">
            <button type="button" className="btn-cancel" onClick={handleClose}>
              Відміна
            </button>
            <button type="submit" className="btn-save">
              Додати
            </button>
          </div>
        </form>
      </AddModal>
    </>
  );
};

export default RecommendationForm;
